import { useEffect, useState } from 'react'

/**
 * Returns a debounced copy of `value`. The returned value only updates after
 * `delayMs` has passed without `value` changing. Rapid changes are coalesced
 * to the final value.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
